import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import styled from 'styled-components'

export const StyledTeamMemberSelectionData = styled(Flexbox)`
    overflow: hidden;
`

export const StyledTeamMemberSelectionName = styled(Text)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
